import AttachmentFileInformation from './AttachmentFileInformation';

export enum ProviderType {
    OneDrivePro,
    OneDriveConsumer,
    Dropbox,
    Box,
    GDrive,
    Facebook,
}

// properties for cloud attachment
export interface CloudAttachmentFileInformation extends AttachmentFileInformation {
    url: string;
    providerType: ProviderType;
    siteId?: string;
    webId?: string;
}

export default CloudAttachmentFileInformation;
